module.exports = __webpack_public_path__ + "static/media/1_edited.58d4198a.jpg";